
import React, { useState, useEffect } from "react";
import { apiGet } from "app/Services/ApiService";
//import { useHistory } from "react-router";
// import { AuthorizationCodeCallback } from "react-oauth2-auth-code-flow";
import { RequestAuthorizationCode } from "react-oauth2-auth-code-flow";
import { oauthClient, scopes } from "Auth";
function Logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('token');
    localStorage.removeItem('loginName');
    localStorage.removeItem('selectedCompanyId')
    localStorage.removeItem('selectedParentCompanyId')
    
    return (<RequestAuthorizationCode
      oauthClient={oauthClient}
      render={({ url }) => {
        let logoutUrl = `${url}&scope=${scopes.join(" ")}`.replace('authorize?', 'logout?').replace('signin-oidc','')
        window.location.href = logoutUrl;
        return (<div>logging out</div>)
      }}
    />
        );
 
}

export default Logout;
